module.exports = __webpack_public_path__ + "static/media/image4.947d2ad5.webp";